import { render, staticRenderFns } from "./CharmNotifications.vue?vue&type=template&id=20a8073e&scoped=true&"
import script from "./CharmNotifications.vue?vue&type=script&lang=js&"
export * from "./CharmNotifications.vue?vue&type=script&lang=js&"
import style0 from "./CharmNotifications.vue?vue&type=style&index=0&id=20a8073e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8073e",
  null
  
)

export default component.exports